import axios from 'axios';
import Cookies from 'js-cookie';
import { getItem } from '../../utility/localStorageControl';

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/api/v1`;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '', params = {}) {
    return client({
      method: 'GET',
      params,
      url: path,
      headers: { ...authHeader() },
    });
  }

  static getFile(path = '') {
    return client({
      method: 'GET',
      url: path,
      responseType: 'blob',
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data,
      headers: { ...authHeader() },
    });
  }

  static delete(path = '', data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      data,
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    const originalRequest = error.config;
    if (!response.data) response.data = {};
    if (response) {
      if (
        response.status === 500 ||
        response.status === 400 ||
        response.status === 404 ||
        response.status === 401 ||
        response.status === 409
      ) {
        if (response?.data?.message === 'Token expired/invalid') {
          Cookies.remove('logedIn');
          Cookies.remove('access_token');
          Cookies.remove('user_id');
          Cookies.remove('user_email');
          window.location = '/';
        }
        // do something here

        response.data.error = response?.data?.message;
        throw new Error(response?.data?.message || 'Something went wrong! Please try again later');
      } else if (response.status === 498) {
        Cookies.remove('logedIn');
        Cookies.remove('access_token');
        Cookies.remove('user_id');
        Cookies.remove('user_email');
        window.location = '/';
      }  else if (response.status > 400) {
        response.data.error = response?.data?.message || 'Something went wrong! Please try again later';
        throw new Error(response?.data?.message || 'Something went wrong! Please try again later');
      } else {
        return originalRequest;
      }
    }
    return Promise.resolve(response);
  },
);
export { DataService };
